import { ProfileResponse } from './interfaces';
import { apiService } from '../../lib/services/api-service';

export const fetchCurrentUser = async () => {
  return await apiService.get<ProfileResponse>('/profile');
};
